import { defineStore } from 'pinia'
import { useAuthStore } from './authStore';
import indexOf from "lodash/indexOf";
import axios from "@dutypay/utilities/authentication/interceptor.js";
import {to} from "await-to-js";
import get from "lodash/get";
import each from "lodash/forEach";

export const useEnvStore = defineStore('envStore', {
    state: () => {
        return {
            debug: false,
            globalLoading: false,
            baseUrl: process.env.VUE_APP_BASE_URL,
            appEnv: process.env.VUE_APP_ENV,
            hosts: [],
            ssoUrl: process.env.VUE_APP_HOST_SSO,
            countries: {},
            regionCountries: {},
            apiKey: process.env.VUE_APP_API_KEY,
            apiEmail: process.env.VUE_APP_EMAIL_API_BASE_URL,
            apiEmailVersion: process.env.VUE_APP_EMAIL_API_VERSION || 'v1',
            apiEmailClient: process.env.VUE_APP_EMAIL_API_CLIENT || 'send/mail',
            contactFormId: process.env.VUE_APP_CONTACT_FORM_ID,
            applicationName: process.env.VUE_APP_APPLICATION_NAME || 'DutyPay',
            applicationVariable: process.env.VUE_APP_APPLICATION_VARIABLE || 'dutypay',
            avatarMenuAccountSettings: [],
            dateFormat: {
                'en-US': 'MM/DD/YYYY',
                'de-DE': 'DD.MM.YYYY',
                'de-AT': 'DD.MM.YYYY',
                'de-CH': 'DD.MM.YYYY',
                'en-GB': 'DD/MM/YYYY',
                'it-IT': 'DD/MM/YYYY',
                'fr-FR': 'DD/MM/YYYY',
                'fr-BE': 'DD/MM/YYYY',
                'fr-LU': 'DD/MM/YYYY',
                'es-ES': 'DD/MM/YYYY',
                'pl-PL': 'DD.MM.YYYY',
                'nl-NL': 'DD-MM-YYYY',
                'bg-BG': 'D.MM.YYYY',
                'bs-BA': 'DD.MM.YYYY',
                'zh-CN': 'YYYY/MM/DD',
                'da-DK': 'DD.MM.YYYY',
                'et-EE': 'DD.MM.YYYY',
                'fi-FI': 'DD.MM.YYYY',
                'el-GR': 'DD/MM/YYYY',
                'el-CY': 'DD/MM/YYYY',
                'he-IL': 'DD/MM/YYYY',
                'ga-IE': 'DD/MM/YYYY',
                'ja-JP': 'YYYY/MM/DD',
                'hr-HR': 'DD.MM.YYYY',
                'lv-LV': 'DD.MM.YYYY',
                'lt-LT': 'YYYY-MM-DD',
                'mt-MT': 'DD/MM/YYYY',
                'pt-PT': 'DD/MM/YYYY',
                'ro-RO': 'DD.MM.YYYY',
                'ru-RU': 'DD.MM.YYYY',
                'sl-SI': 'DD. MM. YYYY',
                'sv-SE': 'YYYY-MM-DD',
                'sk-SK': 'DD.MM.YYYY',
                'cs-CZ': 'DD.MM.YYYY',
                'tr-CY': 'DD.MM.YYYY',
                'tr-TR': 'DD.MM.YYYY',
                'hu-HU': 'YYYY.MM.DD',
                'ar-AE': 'D/\u200FM/\u200FYYYY'
            },
            dateTimeFormat: {
                'en-US': 'MM/DD/YYYY hh:mm a',
                'de-DE': 'DD.MM.YYYY HH:mm',
                'de-AT': 'DD.MM.YYYY HH:mm',
                'de-CH': 'DD.MM.YYYY HH:mm',
                'en-GB': 'DD/MM/YYYY HH:mm',
                'it-IT': 'DD/MM/YYYY HH:mm',
                'fr-FR': 'DD/MM/YYYY HH:mm',
                'fr-BE': 'DD/MM/YYYY HH:mm',
                'fr-LU': 'DD/MM/YYYY HH:mm',
                'es-ES': 'DD/MM/YYYY H:mm',
                'pl-PL': 'DD.MM.YYYY HH:mm',
                'nl-NL': 'DD-MM-YYYY HH:mm',
                'bg-BG': 'D.MM.YYYY H:mm',
                'bs-BA': 'DD.MM.YYYY H:mm',
                'zh-CN': 'YYYY/MM/DD HH:mm',
                'da-DK': 'DD.MM.YYYY HH:mm',
                'et-EE': 'DD.MM.YYYY H:mm',
                'fi-FI': 'DD.MM.YYYY HH.mm',
                'el-GR': 'DD/MM/YYYY hh:mm a',
                'el-CY': 'DD/MM/YYYY hh:mm a',
                'he-IL': 'DD/MM/YYYY HH:mm',
                'ga-IE': 'DD/MM/YYYY HH:mm',
                'ja-JP': 'YYYY/MM/DD HH:mm',
                'hr-HR': 'DD.MM.YYYY H:mm',
                'lv-LV': 'DD.MM.YYYY HH:mm',
                'lt-LT': 'YYYY-MM-DD HH:mm',
                'mt-MT': 'DD/MM/YYYY HH:mm',
                'pt-PT': 'DD/MM/YYYY HH:mm',
                'ro-RO': 'DD.MM.YYYY H:mm',
                'ru-RU': 'DD.MM.YYYY H:mm',
                'sl-SI': 'DD. MM. YYYY H:mm',
                'sv-SE': 'YYYY-MM-DD HH:mm',
                'sk-SK': 'DD.MM.YYYY H:mm',
                'cs-CZ': 'DD.MM.YYYY H:mm',
                'tr-CY': 'DD.MM.YYYY HH:mm',
                'tr-TR': 'DD.MM.YYYY HH:mm',
                'hu-HU': 'YYYY.MM.DD H:mm',
                'ar-AE': 'D/\u200FM/\u200FYYYY HH:mm'
            }
        }
    },
    getters: {
        apiUrls: state => {
            let hosts = state.hosts;
            var urls = {};
            each(hosts, (host) => {
                if(host.type === 'api'){
                    urls[host.hub] = host.url;
                }
            });
            return urls;
        },
        appUrls: state => {
            let hosts = state.hosts;
            var urls = {};
            each(hosts, (host) => {
                if(host.type === 'app'){
                    urls[host.hub] = host.url;
                }
            });
            return urls;
        },
        releasedApplications: state => {
            let hosts = state.hosts;
            var released = [];
            each(hosts, (host) => {
                if (host.active && host.type === "app") {
                    released.push({
                        logo: host.hub,
                        url: host.url
                    });
                }
            });
            return released;
        }
    },
    actions: {
        setGlobalLoading() {
            this.globalLoading = true
        },
        releaseGlobalLoading() {
            this.globalLoading = false
        },
        getDebug() {
            const authStore = useAuthStore()
            if (indexOf(authStore.user.roles, 'global:admin') !== -1) {
                this.debug = Boolean((process.env.VUE_APP_DEBUG === 'true' && process.env.APP_ENV === 'dev') || false)
            }
        },
        async fetchHosts() {
            let err, hosts;
            [err, hosts] = await to(axios({
                url: `${process.env.VUE_APP_API_DUTYPAY}/api/v0/environment`,
                method: 'GET'
            }));
            if(err){
                this.hosts = []
                throw err;
            }
            this.hosts = hosts.data;
            return hosts.data;
        },
        async fetchCountries() {
            let err, countries, regionCountries;
            [err, countries] = await to(axios({
                url: `${process.env.VUE_APP_API_DUTYPAY}/api/v0/countries/environment`,
                method: 'GET'
            }));
            if(err){
                this.countries = {}
                throw err;
            }
            this.countries = countries.data.countries;
            [err, regionCountries] = await to(axios({
                url: `${process.env.VUE_APP_API_DUTYPAY}/api/v0/countries/region`,
                method: 'GET'
            }));
            if(err){
                this.regionCountries = {}
                throw err;
            }
            this.regionCountries = regionCountries.data.countries
            return {
                "regular": countries.data.countries,
                "region": regionCountries.data.countries
            }
        },
        async switchApplication(url) {
            let err, res;
            [err, res] = await to(axios({
                url: `${process.env.VUE_APP_API_DUTYPAY}/api/v0/authenticate/sso`,
                method: 'POST'
            }));
            if (err) {
                throw err;
            }
            let selectedJurisdiction = JSON.parse(localStorage.getItem('jurisdiction'));
            let i18n = get(selectedJurisdiction, 'i18n', undefined);
            window.open(`${url}/#i18n=${i18n}&token=${res.data.ott}`, '_blank');
        }
    }
})